import React from 'react'
import { MessageCircle } from 'lucide-react'
import WhatsAppIntegration from '../../components/WhatsAppIntegration'

const WhatsAppPage: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-white shadow-sm border-b px-6 py-4">
        <div className="flex items-center gap-4">
          <MessageCircle className="h-8 w-8 text-green-600" />
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Integração WhatsApp</h1>
            <p className="text-gray-600">Configure e gerencie a integração com WhatsApp Business</p>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6">
        <WhatsAppIntegration />
      </div>
    </div>
  )
}

export default WhatsAppPage